import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/PlumberOne.png'
import _imports_1 from '@/assets/images/PlumberTwo.png'


const _withScopeId = n => (_pushScopeId("data-v-30b25b02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-separator" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  id: "plumberSectionOne",
  class: "sectionContainer"
}
const _hoisted_4 = { class: "sectionContent graphicRight" }
const _hoisted_5 = { class: "sectionText" }
const _hoisted_6 = { class: "sectionTitle" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sectionGraphic" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "graphic" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1))
const _hoisted_8 = {
  id: "plumberSectionTwo",
  class: "sectionContainer"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sectionGraphic" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "graphic" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ])
], -1))
const _hoisted_10 = {
  class: "sectionContent graphicLeft",
  style: {"opacity":"1"}
}
const _hoisted_11 = { class: "sectionText" }
const _hoisted_12 = { class: "sectionTitle" }
const _hoisted_13 = {
  href: "https://github.com/Zweistein2/AgrarMonitorLauncher",
  class: "undecorated"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("Plumber")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("PlumberTitleOne")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("PlumberTextOne")), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("PlumberSubtitleOne")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("PlumberSubtextOne")), 1)
        ])
      ]),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.$t("PlumberTitleTwo")), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("PlumberTextTwo")) + " ", 1),
            _createElementVNode("a", _hoisted_13, "*" + _toDisplayString(_ctx.$t("hier")) + "* ", 1)
          ]),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("PlumberSubtitleTwo")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("PlumberSubtextTwo")), 1)
        ])
      ])
    ])
  ], 64))
}